<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <v-container fluid>
            <v-form @submit="getUsers" onSubmit="return false">
            <v-card flat>
                <v-container fluid>
                    <v-layout>
                            <v-flex md3 v-if="!limitToOrganization">
                                <v-select
                                          :items="organizations"
                                          label="Filter By Organization"
                                          item-text="name"
                                          v-model="filter.organization"
                                          item-value="id">
                                </v-select>
                            </v-flex>
                            <v-flex md3>
                                <v-text-field type="text"
                                              label="Filter By Last Name"
                                              v-model="filter.lastName"></v-text-field>
                            </v-flex>
                            <v-flex md3>
                                <v-text-field type="text"
                                              label="Filter By First Name"
                                              v-model="filter.firstName"></v-text-field>
                            </v-flex>
                            <v-flex md3>
                                <v-select :items="statuses"
                                          label="Filter By Status"
                                          item-text="name"
                                          v-model="filter.status"
                                          item-value="id"></v-select>
                            </v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex md3>
                                <v-text-field type="text"
                                              label="Filter By E-Mail"
                                              v-model="filter.email"></v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-container>
                    <v-card-actions>
                        <v-btn outlined @click="cancel()" color="warning">
                            Cancel
                        </v-btn>
                        <v-btn outlined type="submit">
                            Search
                            <v-icon right dark>mdi-magnify-plus-outline</v-icon>
                        </v-btn>
                        <v-btn outlined @click="resetFilter()" color="warning">
                            Reset
                            <v-icon right dark>mdi-autorenew</v-icon>
                        </v-btn>
                        <v-btn outlined @click="saveAndClose()" color="success">
                            Save &amp; Close
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
            <v-divider></v-divider>
            <v-data-table
                    :headers="headers"
                    :items="users"
                    :options.sync="pagination"
                    :server-items-length="totalRecords"
                    :loading="loading"
                    class="elevation-1">
                <template v-slot:item.organizationNames="{item}">
                    <div v-for="org in item.organizationNames">
                        {{org}}
                    </div>
                </template>
                <template v-slot:item.phoneNumber="{item}">
                    {{$firstAlertUtils.formatPhone(item.phoneNumber)}}
                </template>
                <template v-slot:item.status="{item}">
                    {{item.status == 'A' ? 'Active' : 'Inactive'}}
                </template>
                <template v-slot:item.actions="{item}">
                    <v-checkbox :key="item.id" @change="setValue(item)"></v-checkbox>
                </template>
            </v-data-table>
        </v-container>
    </div>
</template>

<script>

    import api from '@/api';


    export default {
        name:'SearchUsers',
        props: {
            icons : Object,
            limitToOrganization : Number,
            actions: Array
        },
        data() {
            return {
                headers: [
                    {text: 'E-Mail', value: 'email'},
                    {text: 'First Name', value: 'firstName'},
                    {text: 'Middle Name', value: 'middleName'},
				    {text: 'Last Name', value: 'lastName'},
                    {text: 'Phone', value: 'phoneNumber'},
                    {text: 'Organization(s)', value: 'organizationNames', sortable: false},
                    {text: 'Status', value: 'status'},
                    {text: 'Selected', value: 'actions'}
                ],
                pagination: {
                    //rowsPerPage: 25,
                    //pageNumber: 1
                },
                users: [],
                organizations: [],
                totalRecords: 0,
                statuses: [
                    {id: '', name: 'All'},
                    {id: 'A', name: 'Active'},
                    {id: 'I', name: 'Inactive'}
                ],
                filter: {
                    organization: null,
                    status: null,
                    firstName: null,
                    lastName: null,
                    email: null
                },
                isOpen : false,
                selectedUsers : [],
                loading: false
            }
        },
        watch: {
            pagination: {
                handler() {
                    if (this.isOpen) {
                        this.getUsers();
                    }
                },
                deep: true
            }
        },
        methods: {
            setValue(item) {
                const id = ''+item.id;
                if (!this.selectedUsers) {
                    this.selectedUsers = {};
                }
                if (!this.selectedUsers[id]) {
                    this.selectedUsers[id] = item;
                } else {
                    delete this.selectedUsers[id];
                }
            },
            reset() {
                this.pagination = {
                    rowsPerPage: 25,
                    pageNumber: 1
                };
                this.users = [];
                this.organizations = [];
                this.totalRecords = 0;
                this.filter = {
                    organization: null,
                    status: null,
                    firstName: null,
                    lastName: null,
                    email: null
                };
                this.isOpen = false;
                this.selectedUsers = [];
            },
            saveAndClose() {
                this.$emit('selected',this.selectedUsers.slice());
                this.reset();
            },
            cancel() {
                this.$emit('cancel');
            },
            open() {
                this.reset();
                this.isOpen = true;
                if (!this.limitToOrganization) {
                    api.organization.search().then(r => this.organizations = r.list);
                }
                this.getUsers();
            },
            editUser: function (userId) {
                this.$router.push({'path': '/user/' + userId});
            },
            resetFilter: function () {
                this.filter = {};
                this.getUsers();
            },
            getUsers: function () {
                const that = this;
                that.loading = true;
                return new Promise((resolve, reject) => {
                    let organizationIds = [];
                    if (this.limitToOrganization) {
                        organizationIds.push(this.limitToOrganization);
                    } else {
                        organizationIds = this.filter.organization ? [this.filter.organization] : null
                    }
                    const sortDesc = this.pagination.sortDesc ? (!!this.pagination.sortDesc[0]) : false;
                    const sortOrder = sortDesc ? 'DESC' : 'ASC';
                    api.user.search({
                        pageNumber: this.pagination.page - 1,
                        rowsPerPage: this.pagination.itemsPerPage,
                        sortBy: this.pagination.sortBy,
                        sortOrder: sortOrder,
                        organizationIds: organizationIds,
                        firstName: this.filter.firstName,
                        lastName: this.filter.lastName,
                        status: this.filter.status,
                        email: this.filter.email
                    }).then(response => {
                        that.users = response.list;
                        that.totalRecords = response.totalRecords;
                        resolve();
                    }).catch(error => {
                        reject();
                    }).finally(() => {
                        that.loading = false;
                    });
                });
            }
        }
    }
</script>